import { useOrganisation } from "../../providers/OrganisationProvider";
import { Typography } from "@mui/material";
import { useOrganisationStyles } from "../../layout/organisation/useOrganisationStyles";
import { T } from "../../util/t";
import { FeaturedEvents } from "../../layout/organisation/FeaturedEvents";
import { Highlights } from "../../layout/organisation/Highlights";

const OrganisationPage = () => {
    const organisation = useOrganisation();
    const classes = useOrganisationStyles();

    return (
        <>
            <Highlights organisation={organisation} />
            <section className={classes.section}>
                <Typography variant="h7" component="h2" className={classes.title}><T>Events</T></Typography>
                <FeaturedEvents organisation={organisation}/>
            </section>
        </>
    );
};
export default OrganisationPage;
